// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { FileKind } from "../../../define/FileKind";
import { SuperPowerKind } from "../../../define/SuperPowerKind";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SuperPowerCompoundLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodePropList: cc.Node = null;

    @property(cc.Node)
    nodeConfirm: cc.Node = null;
    

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.nodeConfirm.active = false;
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.SuperPowerCompoundLayer, this.node);
        this.initLayer();
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.SuperPowerCompoundLayer);
    }

    initLayer() {
        let newPropList = this._carryData && this._carryData.newPropList;
        let cCount = 0;
        this.nodePropList.children.forEach((v, i)=> {
            let propId = SuperPowerKind.SuperPowerPropList[i];
            let propData = NormalGameManager._instance.getOneGood(propId);
            v.active = false;
            if (propData && propData.num > 0) {
                if (newPropList && newPropList.includes(propId)) {
                    return;
                }
                v.active = true;
                cCount++;
            }
        });
        
        if (newPropList) {
            this.startShowAni(newPropList);
        }
        // this.nodeConfirm.active = false;
        this.nodeConfirm.active = cCount >= SuperPowerKind.SuperPowerPropList.length;
    }

    startShowAni(showList: number[]) {
        if (!showList || showList.length <= 0) {
            return;
        }
        // 动画效果
        showList.forEach((v)=> {
            let idx = SuperPowerKind.SuperPowerPropList.indexOf(v);
            let nodeItem = this.nodePropList.children[idx];
            nodeItem.active = true;
            let oriHeight = nodeItem.height;
            nodeItem.height = 0;
            cc.tween(nodeItem)
            .to(1, {height: oriHeight})
            .start();
        });
    }

    onClickHint() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsView.openPopupLayer(
            'prefab/SuperPowerHintLayer'
            , BUNDLE_SMALL_NAME.superPowerBundle
            , null
            , null
            , UI_Z_INDEX.DIALOG
        );
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();

        for (let o of SuperPowerKind.SuperPowerPropList) {
            let propId = o;
            let propData = NormalGameManager._instance.getOneGood(propId);
            if (!propData || propData.num <= 0) {

                return;
            }
        }

        for (let o of SuperPowerKind.SuperPowerPropList) {
            let propId = o;
            NormalGameManager._instance.onOutGoods(propId);
        }
        
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.SuperPowerSelectLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SuperPowerSelectLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
